export default "/assets/no_results_compass-a0b0d13adfd6575d701fb8aa0bfebd3f08a60c617609c54c44ad9116f5c88600.svg";